<template>
    <div class="order-taking-list">
        <HeaderNav
            header-title="接单列表"
            left-icon-name="2"
            right-icon-name=""
        ></HeaderNav>
        <div class="warpper" :style="{height: contentHeight}" :class="{ 'no_data': isActive }">
            <van-list
                v-model="loading"
                :finished="finished"
                :immediate-check="false"
                :finished-text="finishedText"
                :error.sync="error"
                :error-text="errorText"
                @load="onLoad"
            >
                <div
                    class="materialPlan-item"
                    v-for="(item) in materialPlanList"
                    :key="item.poid"
                    :immediate-check="false"
                >
                    <div class="corner-marker order-wjd" v-if="item.supplier_state===0">
                        <p class="text">
                            未接单
                        </p>
                    </div>
                    <div class="corner-marker order-yjd" v-else-if="item.supplier_state===1">
                        <p class="text">
                            已接单
                        </p>
                    </div>
                    <div class="corner-marker order-ytd" v-else-if="item.supplier_state===2">
                        <p class="text">
                            已退单
                        </p>
                    </div>
                    <div class="corner-marker order-yap" v-else-if="item.supplier_state===3">
                        <p class="text">
                            已安排
                        </p>
                    </div>
                    <div class="corner-marker order-gyz" v-else-if="item.supplier_state===4">
                        <p class="text">
                            供应中
                        </p>
                    </div>
                    <div class="corner-marker order-ywc" v-else-if="item.supplier_state===5">
                        <p class="text">
                            供应完成
                        </p>
                    </div>
                    <ul>
                        <li class="tit">
                            <span class="pre-icon materialPlan07"></span>
                            <span class="info">供应单编号:{{ item.no }}</span>
                        </li>
                        <li class="name-length">
                            <span class="pre-icon materialPlan01"></span>
                            <span class="info">供应商名称:{{ item.supplier_name }}</span>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan01"></span>
                            <span class="info">物料名称:{{ item.goods_name }}</span>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan02"></span>
                                    <span class="info">物料子类:{{ item.type_name }}</span>
                                </van-col>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan03"></span>
                                    <span class="info">规格:{{ item.spec_name }}</span>
                                </van-col>
                            </van-row>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan05"></span>
                            <span class="info info-bar">计划量:{{ item.supply_count }}吨</span>
                        </li>
                        <li class="name-length">
                            <span class="pre-icon materialPlan04"></span>
                            <span class="info">供应场站:{{ item.station_name }}</span>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan06"></span>
                            <span class="info">供应时间:{{ item.supply_date }}</span>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan06"></span>
                            <span class="info">要求送货时间:{{ item.time_required }}</span>
                        </li>
                    </ul>
                    <div class="btn-wrapper" v-if="item.supplier_state === 0">
                        <span class="vertical-bar"></span>
                        <van-row type="flex" justify="space-around">
                            <van-col span="8">
                                <span class="btn btn_order_taking" @click="confirmTakOrder(item)">
                                    接单
                                </span>
                            </van-col>
                            <van-col span="8">
                                <span class="btn btn_refuse" @click="btnClick('orderRefuse',item)">
                                    拒绝
                                </span>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import { Toast, Dialog } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            // 接单list
            materialPlanList: [],
            loading: true,
            finished: false,
            page: {
                pageindex: 1,
                pagesize: 20,
            },
            contentHeight: '',
            isActive: false,
            error: false,
            errorText: '',
            finishedText: '没有更多了',
        };
    },
    methods: {
        // 确认接单
        confirmTakOrder(item) {
            Dialog.confirm({
                message: '确定要接单？',
            }).then(() => {
                // on confirm
                Toast.loading({
                    message: '请求中...',
                    forbidClick: false,
                    loadingType: 'spinner',
                });
                this.$axios
                    .put('/interfaceApi/procurement/daily/supply/receive/' + item.no)
                    .then(() => {
                        Toast.success({
                            message: '接单成功',
                            duration: 500,
                        });
                        this.page.pageindex = 1;
                        this.materialPlanList = [];
                        this.getList();
                    })
                    .catch(error => {
                        this.$toast('message:' + error.Errorcode.Message + '');
                    });
            }).catch(() => {
                // on cancel
            });
        },
        // 页面跳转
        btnClick(name, item) {
            this.$router.isBack = 2;
            this.$router.push({ name: name, params: { no: item.no } });
        },
        // 滚动条滑到底部触发的事件
        onLoad() {
            setTimeout(() => {
                this.page.pageindex += 1;
                this.getList();
            }, 200);
        },
        // 获取接单列表
        getList() {
            this.$axios
                .get('/interfaceApi/procurement/daily/supply/get_supply_receivce_page?pageindex='
                 + this.page.pageindex + '&pagesize='
                 + this.page.pagesize)
                .then(res => {
                    this.loading = false;
                    this.materialPlanList.push(...res.rows);
                    if (this.materialPlanList.length >= res.total) {
                        this.finished = true;
                    }
                    if (this.materialPlanList.length === 0 ) {
                        this.finishedText = '';
                        this.isActive = true;
                        this.finished = true;
                    } else {
                        this.isActive = false;
                    }
                })
                .catch(error => {
                    this.error = true;
                    this.loading = false;
                    this.errorText = error.ErrorCode.Message;
                });
        },
    },
    mounted() {
        // 初始化接单列表数据
        this.getList();
        this.contentHeight = document.documentElement.clientHeight - 44.8 + 'rpx';
    },
};
</script>

<style lang="stylus">
.order-taking-list
    padding-top 44rpx
    height calc(100% - 44rpx)
    .warpper
        height 100%
        width 100%
        background #F0F0F0
        overflow-y auto
        padding 0 12rpx 12rpx 12rpx
        &.no_data
            background url(./../../assets/images/common/no_data.png) left center no-repeat
            background-size contain
        .materialPlan-item
            width 100%
            background #ffffff
            margin-top 15rpx
            position relative
            overflow hidden
            padding 16rpx
            color #666666
            font-size 14rpx
            li
                overflow hidden
                margin-bottom 10rpx
                &.name-length
                    display flex
                    .info
                        flex 1
                .pre-icon
                    width 16rpx
                    height 16rpx
                    float left
                    background-size 100% 100%
                    background-repeat no-repeat
                    display inline-block
                    margin 2rpx 10rpx 0 0
                    &.materialPlan01
                        background-image url(./../../assets/images/icons/icon_gy_3.png)
                    &.materialPlan02
                        background-image url(./../../assets/images/icons/icon_34.png)
                    &.materialPlan03
                        background-image url(./../../assets/images/icons/icon_gy_5.png)
                    &.materialPlan04
                        background-image url(./../../assets/images/icons/icon_gy_2.png)
                    &.materialPlan05
                        background-image url(./../../assets/images/icons/icon_30.png)
                    &.materialPlan06
                        background-image url(./../../assets/images/icons/icon_gy_7.png)
                    &.materialPlan07
                         background-image url(./../../assets/images/icons/icon_gy_1.png)
                .info
                    float left
                .info-bar
                    float left
                    width 125rpx
                    white-space nowrap
                    text-overflow ellipsis
                    overflow hidden
                &.tit
                    font-size 16rpx
                    color #061F3E
            .corner-marker
                width 60rpx
                height 60rpx
                position absolute
                right -30rpx
                top -30rpx
                transform rotate(45deg)
                -webkit-transform rotate(45deg)
                -moz-transform rotate(45deg)
                font-size 10rpx
                text-align center
            .order-wjd
                background #FF6600
                .text
                    position absolute
                    bottom 0
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .order-yjd
                background #00A84B
                .text
                    position absolute
                    bottom 0
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .order-ytd
                background #D6010F
                .text
                    position absolute
                    bottom 0
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .order-yap
                background #0101B5
                .text
                    position absolute
                    bottom 0
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .order-gyz
                background #02ADBE
                .text
                    position absolute
                    bottom 0
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .order-ywc
                background #979EA7
                .text
                    position absolute
                    bottom 0
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .btn-wrapper
                border-top 2rpx solid #F0F0F0
                padding-top 15rpx
                position relative
                .btn
                    width 100rpx
                    height 30rpx
                    line-height 30rpx
                    text-align center
                    display block
                    border-radius 4rpx
                    cursor pointer
                    &.btn_order_taking
                        background #5494F3
                        color #ffffff
                        line-height 30rpx
                    &.btn_refuse
                        border 1px solid rgba(85,136,241,1)
                        color #5494F3
                        line-height 30rpx
                .vertical-bar
                    width 2rpx
                    height 15rpx
                    background rgba(215,215,215,1)
                    position absolute
                    top 50%
                    left 50%
                    margin-left -2rpx
</style>
<style>
    .materialPlan-box .van-list__error-text, .van-list__finished-text, .van-list__loading{
        position: relative;
        height: 50rpx;
    }
    .materialPlan-box .van-loading__spinner{
        position: relative!important;
        top: 0!important;
        left: 0!important;
        display: inline-block;
        width: 30px;
        max-width: 100%;
        height: 30px;
    }

</style>